<!-- real-time-overview-agent.component.html -->
<div class="content-div">
  <div class="info-bar">
    <app-breadcrumbs [breadcrumbs]="BreadcrumbsLink"></app-breadcrumbs>
    <app-basic-button id="help-btn-real-time-overview-agent" type="secondary" isIcon="true" size="medium" (click)="openHelpOverview()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </div>
  <div class="top-bar">
    <span class="page-header">{{ 'realtime:overviewAgent' | i18next }} <span class="header-details">{{ queueDescription || '‒' }}</span></span>
      <div class="right">
      <app-filter-input id="filter-input-real-time-overview-agent" [(model)]="filter" (modelChange)="applyFilterFromProperty()"
      [placeholder]="'realtime:shared_lang_tableFilterLabel' | i18next" [width]="'350px'"></app-filter-input>
      </div>
  </div>

  <div class="content">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

    <!-- No-data template (used by both tables) -->
    <ng-template #noData>
      <div class="no-items">
        {{ 'realtime:noResults' | i18next }}
      </div>
    </ng-template>

    <!-- ===== Overview table ===== -->
    <table mat-table [dataSource]="overviewDS" class="mat-elevation-z2 full-width-table">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:agentGroup' | i18next : { defaultValue: 'Agents' } }}</th>
        <td mat-cell *matCellDef="let r">{{ r.name }}</td>
      </ng-container>

      <ng-container matColumnDef="available">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:status_available' | i18next }}</th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.available }}</td>
      </ng-container>

      <ng-container matColumnDef="connecting">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:connecting' | i18next }}</th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.connecting }}</td>
      </ng-container>

      <ng-container matColumnDef="engaged">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:engaged' | i18next }}</th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.engaged }}</td>
      </ng-container>

      <ng-container matColumnDef="unavailable">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:unavailable' | i18next }}</th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.unavailable }}</td>
      </ng-container>

      <ng-container matColumnDef="wrapup">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:status_wrapUp' | i18next }}</th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.wrapup }}</td>
      </ng-container>

      <ng-container matColumnDef="noanswer">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:status_noAnswer' | i18next }}</th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.noanswer }}</td>
      </ng-container>

      <ng-container matColumnDef="pause">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:status_pause' | i18next }}</th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.pause }}</td>
      </ng-container>

      <ng-container matColumnDef="loggedoff">
        <th mat-header-cell *matHeaderCellDef>{{ 'realtime:status_loggedOff' | i18next }}</th>
        <td mat-cell *matCellDef="let r" class="text-right">{{ r.loggedoff }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="overviewDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: overviewDisplayedColumns"></tr>

      <!-- No data row for overview table -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="overviewDisplayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>
    </table>

    <br />

    <div class="section-title">
      {{ 'realtime:queueDetailsAgent' | i18next }}<span>{{ queueDescription || '‒' }}</span>
      <!-- <i class="fal fa-question-circle info-icon" (click)="openHelpDetails()"></i> -->
    </div>

    <!-- ===== Details table ===== -->
    <table mat-table [dataSource]="detailsDS" matSort class="mat-elevation-z2 full-width-table">
      <!-- Agent -->
      <ng-container matColumnDef="agent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:agentstatus_name' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" [class.user-offline]="r.faded">
        <a [routerLink]="['/real-time/ticker-agents/details', r.userId]" [matTooltip]="'realtime:statusdetails_tooltip_details' | i18next" matTooltipClass="tooltip-font-14">{{ r.formattedName }} ({{ r.name }})</a>
        </td>
      </ng-container>

      <!-- Phone -->
      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:usergroups_details_phone_number' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="right align-right-sort">
          {{ r.formattedPhoneNumber || 'Softphone' }}
        </td>
      </ng-container>

      <!-- Profile -->
      <ng-container matColumnDef="profile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:usergroups_details_profile' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r">
          <a *ngIf="r.userOwned === 1" href="#" (click)="$event.preventDefault(); onViewProfile(r)">
            {{ r.profileName }}
          </a>
          <span *ngIf="r.userOwned !== 1">{{ r.profileName }}</span>
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:status' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="statusColumn">
          <i class="fas fa-circle status-color" [style.color]="r.statusColor"></i>
          <!-- <img *ngIf="r.statusIcon" [src]="r.statusIcon" [alt]="r.formattedStatus" /> -->
          {{ r.formattedStatus }}
        </td>
      </ng-container>

      <!-- Time in status -->
      <ng-container matColumnDef="timeInStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'realtime:statusduration' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" class="right align-right-sort text-right">
          {{ r.formattedSecondsInStatus }} {{ r.statusId }}
        </td>
      </ng-container>

      <!-- Actions -->
      <!-- Actions column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef >
          {{ 'realtime:usergroups_details_changeStatus' | i18next }}
        </th>
        <td mat-cell *matCellDef="let r" >
          <ng-container *ngIf="canChangeAgentStatus; else dash">
            <ng-container *ngFor="let action of getActions(r); let first = first">
              <span class="sep" *ngIf="!first"> | </span>

              <a id="action-link-{{r.userId}}-{{action.action}}-real-time-overview-agent" href="#" (click)="$event.preventDefault(); action.click()">
                {{ action.label | i18next }}
              </a>
            </ng-container>
          </ng-container>
          <ng-template #dash>‒</ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="detailsDisplayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: detailsDisplayedColumns"
          [attr.data-user-id]="row.userId"
          [class.user-offline]="row.faded">
      </tr>

      <!-- No data row for details table -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="detailsDisplayedColumns.length">
          <ng-container *ngTemplateOutlet="noData"></ng-container>
        </td>
      </tr>
    </table>
  </div>
</div>
